import { useRef, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import IconInput from "./IconInput";

export default function Password(props: any) {
  const [showPassword, setShowPassword] = useState(false);

  const inputRef = useRef<HTMLInputElement | null>(null);
  const handleClickShowPassword = (e: any) => {
    setShowPassword((show) => !show);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <IconInput
      inputRef={inputRef}
      startComponent={<VpnKeyIcon />}
      endComponent={
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          edge="end"
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      }
      {...props}
      type={showPassword ? "text" : "password"}
    />
  );
}
